<mat-card fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" fxFlex="100">
  <mat-card-title>Edit Duty Entry</mat-card-title>
  <mat-card-subtitle>{{ (employee$ | async)?.fullName }}</mat-card-subtitle>
  <mat-divider></mat-divider>
  <mat-card-content *ngIf="dutyLogData$ | async; let dutyLogData; else: loading">
    <fl-duty-edit-form
      [dutyLogEntry]="dutyLogData.current"
      [prevLogEntry]="dutyLogData.previous"
      [nextLogEntry]="dutyLogData.next"
    ></fl-duty-edit-form>
  </mat-card-content>
  <mat-divider> </mat-divider>
  <mat-card-actions *ngIf="formCmp">
    <button mat-raised-button color="primary" (click)="update()" [disabled]="formCmp.form.invalid">
      Update
    </button>
  </mat-card-actions>

  <ng-template #loading>
    <fl-loading-container [loading]="true"> </fl-loading-container>
  </ng-template>
</mat-card>
